import { RegistryWidgetsType } from '@rjsf/utils';
import { InputCustom, DropdownCustom } from './widgets';

export const customWidgets: RegistryWidgetsType = {
  TextWidget: InputCustom,
  SelectWidget: DropdownCustom,
};
